import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import {
    RecordContextProvider,
    SimpleListLoading,
    useListContext,
} from 'react-admin';
import { ExpensesClaimSummary } from '@wwf/sdk';

export const ExpensesClaimListContent = ({
    openEditDrawer,
}: {
    openEditDrawer: (id: ExpensesClaimSummary['id']) => void;
}) => {
    const { data, error, isPending } = useListContext<ExpensesClaimSummary>();

    if (isPending) {
        return <SimpleListLoading hasLeftAvatarOrIcon hasSecondaryText />;
    }
    if (error) return null;
    if (!data?.length) {
        return (
            <Stack p={2}>
                <Typography>No expenses claims found</Typography>
            </Stack>
        );
    }

    return (
        <List dense>
            {data.map(expensesClaim => (
                <RecordContextProvider
                    key={expensesClaim.id}
                    value={expensesClaim}
                >
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => openEditDrawer(expensesClaim.id)}
                            alignItems="center"
                        >
                            <ListItemText
                                primary={expensesClaim.name}
                                secondary={
                                    expensesClaim.details ?? expensesClaim.url
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                </RecordContextProvider>
            ))}
        </List>
    );
};
